<route>
{
    "name": "transports-index",
    "meta": {
        "title": "Comenzi de transport",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid grid-list-xl>
          <v-row>
              <v-col>
                  <suppliers-index></suppliers-index>
              </v-col>
          </v-row>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import SuppliersIndex from 'Components/transports/Index'

export default {
    components: {
        CompanyLayout,
        SuppliersIndex
    }
};
</script>
